import styled from "@emotion/styled"

export const Wrapper = styled.div`
  &.error > div {
    border-color: ${(p) => p.theme.colors.red};
  }
`
